var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _path, _path2, _g19, _g20, _g21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrk19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wrk-19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 179.449,
    height: 80.614,
    viewBox: "0 0 179.449 80.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1616",
    "data-name": "Rectangle 1616",
    width: 179.449,
    height: 80.614,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60259",
    "data-name": "Path 60259",
    d: "M270.61,21.761l-43.686,6.865a9.605,9.605,0,0,0-8,10.98l6.865,43.686a9.607,9.607,0,0,0,9.464,8.116h.029a9.689,9.689,0,0,0,1.487-.118l43.686-6.865a9.607,9.607,0,0,0,8.116-9.452v-.03a9.756,9.756,0,0,0-.118-1.5l-6.865-43.686a9.607,9.607,0,0,0-9.476-8.116,9.7,9.7,0,0,0-1.5.118",
    transform: "translate(-218.808 -21.643)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.546,
    y1: 1,
    x2: -1.539,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c7fb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#00b8b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b8b2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60260",
    "data-name": "Path 60260",
    d: "M47.2,21.028l.516,2.266,17.373-3.379-.6-2.306Z",
    transform: "translate(-47.196 -17.609)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1.323,
    y1: 12.627,
    x2: -1.295,
    y2: 12.627,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#181c2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#414860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414860"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60261",
    "data-name": "Path 60261",
    d: "M141.786,7.155a4.85,4.85,0,1,1,4.849,4.89,4.862,4.862,0,0,1-4.849-4.89M146.636,0a7.237,7.237,0,0,0-7.195,7.155,7.2,7.2,0,1,0,14.39,0A7.237,7.237,0,0,0,146.636,0Z",
    transform: "translate(-139.441)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -4.857,
    y1: 5.617,
    x2: -4.823,
    y2: 5.617,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60262",
    "data-name": "Path 60262",
    d: "M152.283,131.015a3.836,3.836,0,1,0,7.672,0,3.836,3.836,0,0,0-7.672,0",
    transform: "translate(-152.283 -127.198)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -9.95,
    y1: 2.196,
    x2: -9.885,
    y2: 2.196,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60263",
    "data-name": "Path 60263",
    d: "M23.376,65.512a8.964,8.964,0,1,1,8.985,8.944,8.975,8.975,0,0,1-8.985-8.944m22.62,0A13.571,13.571,0,0,0,40.351,54.46H41.5a10.266,10.266,0,0,1,.636,20.513A13.439,13.439,0,0,0,46,65.512m98.17,9.581a11.23,11.23,0,0,1,0-22.461,11.089,11.089,0,0,1,11.011,9.342l2.346,13.158Zm-17.849-11.25a13.194,13.194,0,0,0,5.963,11.131h-13.4L118.9,75l-16.041-.027.027.04h-1.944A17.064,17.064,0,0,0,87.348,47.7H60.794l1.192,6.758H87.348a10.276,10.276,0,0,1,.04,20.553l-29.3-.04.026.04H55.1A17.065,17.065,0,0,0,41.5,47.7H18.526L19.72,54.46h4.65A13.638,13.638,0,0,0,22.58,75.011l-8.468-.038a24.546,24.546,0,0,0-.4-5.089L9.738,47.7H3.021L6.956,69.646C8.428,78.074,5.326,85.428,0,91.391l4.77,5.366c3.06-2.584,7.393-9.1,8.826-16.895l1.232,1.868,9.3.04-.005-.029,17.42.029a16.526,16.526,0,0,0,6.281-1.232l.8,1.192,17.054.04-.006-.035,21.72.035a16.684,16.684,0,0,0,6.48-1.312l.835,1.272,19.758.08-.012-.066,13.06.026-.006-.036,38.051.036-3.737-20.989c-1.55-8.866-7.712-14.788-17.65-14.788a17.848,17.848,0,0,0-17.849,17.849",
    transform: "translate(0 -45.993)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0,
    y1: 1.134,
    x2: 0.003,
    y2: 1.134,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60264",
    "data-name": "Path 60264",
    d: "M267.858,128.753l.556,2.267,17.333-3.379-.557-2.266Z",
    transform: "translate(-267.858 -125.374)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -7.506,
    y1: 3.147,
    x2: -7.478,
    y2: 3.147,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60265",
    "data-name": "Path 60265",
    d: "M265.22,70.447A11.258,11.258,0,0,0,276.435,81.7l13.358.047-2.341-13.16a11.088,11.088,0,0,0-11.017-9.34,11.2,11.2,0,0,0-11.215,11.2",
    transform: "translate(-265.22 -59.244)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -5.41,
    y1: 2.263,
    x2: -5.39,
    y2: 2.263,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60267",
    "data-name": "Path 60267",
    d: "M285.355,86.882a10.228,10.228,0,0,1,4.85,8.729h3.119A13.331,13.331,0,0,0,287,84.233Z",
    transform: "translate(-285.355 -84.233)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60268",
    "data-name": "Path 60268",
    d: "M301.349,75.228c-.189.044-.829.449-.785.639l.034.145-2.082.488.433,1.851,2.081-.487h0l.034.145c.044.189.754.092.945.048a.353.353,0,0,0,.263-.424l-.5-2.141a.353.353,0,0,0-.343-.272.346.346,0,0,0-.081.01",
    transform: "translate(-298.516 -75.218)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -39.361,
    y1: 13.7,
    x2: -39.23,
    y2: 13.7,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60269",
    "data-name": "Path 60269",
    d: "M290.545,83.357h0m0,0h0Z",
    transform: "translate(-290.542 -83.356)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -44281.262,
    y1: 18065.234,
    x2: -44128.852,
    y2: 18065.234,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60271",
    "data-name": "Path 60271",
    d: "M289.331,83.147h0m0,0h0Z",
    transform: "translate(-289.33 -83.146)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -54175.766,
    y1: 25136.219,
    x2: -53988.52,
    y2: 25136.219,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60272",
    "data-name": "Path 60272",
    d: "M304.007,74.55h0Z",
    transform: "translate(-304.006 -74.55)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -95785.258,
    y1: 52346.465,
    x2: -95513.57,
    y2: 52346.465,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60274",
    "data-name": "Path 60274",
    d: "M286.732,84.2c-.042.014-.083.029-.123.046a1.844,1.844,0,1,0,2.411,1,1.811,1.811,0,0,0-.364-.56,1.833,1.833,0,0,0-.788-.492,1.6,1.6,0,0,0-.237-.057,1.662,1.662,0,0,0-.245-.027l-.073,0a1.831,1.831,0,0,0-.581.094",
    transform: "translate(-285.469 -84.105)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -38.111,
    y1: 10.315,
    x2: -37.978,
    y2: 10.315,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60276",
    "data-name": "Path 60276",
    d: "M291.553,77.358l-3.59.839.455,2.054a1.994,1.994,0,0,1,.232-.011,2.03,2.03,0,0,1,.305.032l0,0h0v0a2.115,2.115,0,0,1,.295.07,2.338,2.338,0,0,1,.77.44l2.22-.465a1.6,1.6,0,0,0,.236-.075,1.522,1.522,0,0,0,.835-.877l-.38-1.627a1.553,1.553,0,0,0-.594-.356,1.536,1.536,0,0,0-.445-.067,1.51,1.51,0,0,0-.345.04",
    transform: "translate(-287.963 -77.318)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -23.996,
    y1: 9.237,
    x2: -23.913,
    y2: 9.237,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1610",
    "data-name": "Rectangle 1610",
    width: 10.529,
    height: 6.769,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60279",
    "data-name": "Path 60279",
    d: "M27.637,103.8l-.516,4.89,1.232,1.868,9.3.012-1.544-6.731Z",
    transform: "translate(-27.121 -103.804)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1612",
    "data-name": "Rectangle 1612",
    width: 17.849,
    height: 6.798,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60280",
    "data-name": "Path 60280",
    d: "M102.68,103.844a12.29,12.29,0,0,1-7.274,5.526l.8,1.193,17.054.04-2.8-6.791-4.788-.007.026.04Z",
    transform: "translate(-95.406 -103.804)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1614",
    "data-name": "Rectangle 1614",
    width: 15.792,
    height: 6.818,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60281",
    "data-name": "Path 60281",
    d: "M202.862,103.808l-6.614,0,.026.04H194.33s-3.245,4.49-7.076,5.446l.835,1.272,14.957.06Z",
    transform: "translate(-187.254 -103.804)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3805",
    "data-name": "Group 3805",
    clipPath: "url(#clip-path)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3753",
    "data-name": "Group 3753",
    transform: "translate(109.685 10.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3752",
    "data-name": "Group 3752",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1591",
    "data-name": "Rectangle 1591",
    width: 70.47,
    height: 69.764,
    transform: "translate(-0.706 0)",
    fill: "url(#linear-gradient)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3755",
    "data-name": "Group 3755",
    transform: "translate(23.659 8.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3754",
    "data-name": "Group 3754",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1592",
    "data-name": "Rectangle 1592",
    width: 17.889,
    height: 5.685,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3757",
    "data-name": "Group 3757",
    transform: "translate(69.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3756",
    "data-name": "Group 3756",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1593",
    "data-name": "Rectangle 1593",
    width: 14.39,
    height: 14.351,
    transform: "translate(0)",
    fill: "url(#linear-gradient-3)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3759",
    "data-name": "Group 3759",
    transform: "translate(76.337 63.762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3758",
    "data-name": "Group 3758",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1594",
    "data-name": "Rectangle 1594",
    width: 7.672,
    height: 7.672,
    fill: "url(#linear-gradient-4)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3761",
    "data-name": "Group 3761",
    transform: "translate(0 23.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3760",
    "data-name": "Group 3760",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1595",
    "data-name": "Rectangle 1595",
    width: 165.554,
    height: 50.764,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-5)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3763",
    "data-name": "Group 3763",
    transform: "translate(134.273 62.848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3762",
    "data-name": "Group 3762",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1596",
    "data-name": "Rectangle 1596",
    width: 17.889,
    height: 5.645,
    fill: "url(#linear-gradient-6)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3765",
    "data-name": "Group 3765",
    transform: "translate(132.951 29.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3764",
    "data-name": "Group 3764",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1597",
    "data-name": "Rectangle 1597",
    width: 24.573,
    height: 22.5,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-7)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3767",
    "data-name": "Group 3767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3766",
    "data-name": "Group 3766",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60266",
    "data-name": "Path 60266",
    d: "M290.205,95.612a10.416,10.416,0,0,0-.1-1.443,10.223,10.223,0,0,0-4.751-7.287L287,84.233a13.321,13.321,0,0,1,6.245,9.946,13.7,13.7,0,0,1,.075,1.433",
    transform: "translate(-142.311 -42.008)",
    fill: "#fff"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3769",
    "data-name": "Group 3769",
    transform: "translate(143.044 42.225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3768",
    "data-name": "Group 3768",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_1599",
    "data-name": "Rectangle 1599",
    width: 11.53,
    height: 14.036,
    transform: "translate(-1.682 -1.213)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAcCAYAAACK7SRjAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD5SURBVEhLY/z//z8DrQATlKYJGDUcKxg1HCsYNRwrGDUcKxg1HA7+/fvH+ufPHy4Qm+TKAqieGWQADP/994/l318EH4ZFRIQvYjUcWRFQM4SNxQAYBluAJqairLQGbviXL1+l0RXAMNwCdIxk4d9/f2FssEUmxkbtcMOfPH3mAFMIx9g148TIvnRxdkyEG3716vU0dNvRMZFBBKZDggJs4IYfPXa8G1kSzQC4ZcQF0T/WlKR4cZQI3bxl21aYJFwTAsNTBS4LoMbAAYrhi5csvwVTiM0AoFqS8gWK4ZOnzkBwKAC52RmMIJosw2GaCQGchhNrAG7AwAAAY+3Hk027FX8AAAAASUVORK5CYII="
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3771",
    "data-name": "Group 3771",
    transform: "translate(149.641 37.706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3770",
    "data-name": "Group 3770",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1600",
    "data-name": "Rectangle 1600",
    width: 3.802,
    height: 3.132,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-8)"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3773",
    "data-name": "Group 3773",
    transform: "translate(145.644 41.785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3772",
    "data-name": "Group 3772",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1601",
    "data-name": "Rectangle 1601",
    width: 0.003,
    height: 0.002,
    transform: "translate(0 0) rotate(-13.13)",
    fill: "url(#linear-gradient-9)"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3775",
    "data-name": "Group 3775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3774",
    "data-name": "Group 3774",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60270",
    "data-name": "Path 60270",
    d: "M289.108,85.93a2.372,2.372,0,1,1-1.813-2.824,2.373,2.373,0,0,1,1.813,2.824",
    transform: "translate(-141.843 -41.419)",
    fill: "#fff"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3777",
    "data-name": "Group 3777",
    transform: "translate(145.037 41.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3776",
    "data-name": "Group 3776",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1603",
    "data-name": "Rectangle 1603",
    width: 0.003,
    height: 0.002,
    transform: "matrix(0.974, -0.228, 0.228, 0.974, 0, 0)",
    fill: "url(#linear-gradient-10)"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3779",
    "data-name": "Group 3779",
    transform: "translate(152.393 37.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3778",
    "data-name": "Group 3778",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1604",
    "data-name": "Rectangle 1604",
    width: 0.002,
    height: 0.001,
    transform: "translate(0 0) rotate(-13.098)",
    fill: "url(#linear-gradient-11)"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3781",
    "data-name": "Group 3781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3780",
    "data-name": "Group 3780",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60273",
    "data-name": "Path 60273",
    d: "M278.872,83.345c.065.022.124.062.191.08h0a2.337,2.337,0,0,0,1.089.01,3.548,3.548,0,0,0,.654-.266,2.32,2.32,0,0,0,.815-.8,1.714,1.714,0,0,0,.084-.2,6.946,6.946,0,0,0,.24-.816,2.148,2.148,0,0,0-.317-1.35l1.837-.384h.007a2.235,2.235,0,0,0,.348-.112A2.21,2.21,0,0,0,285,78.3l1.62-.378a.075.075,0,0,0,.006.009.46.46,0,0,0,.1.08.605.605,0,0,0,.173.074,1.2,1.2,0,0,0,.3.035c.066,0,.132,0,.2-.006.086-.006.169-.015.245-.025.1-.014.185-.028.249-.042h0a.722.722,0,0,0,.109-.035.706.706,0,0,0,.416-.812l-.5-2.141h0a.778.778,0,0,0-.035-.111.707.707,0,0,0-.813-.417.866.866,0,0,0-.125.041,2.239,2.239,0,0,0-.288.152,2.7,2.7,0,0,0-.3.212,1.509,1.509,0,0,0-.18.169.907.907,0,0,0-.089.121.643.643,0,0,0-.058.157l-1.632.381a2.139,2.139,0,0,0-1.946-.492l-3.877.906a2.514,2.514,0,0,0-1.291-.052h0l-1.835.43a.352.352,0,1,0,.161.686l1.834-.429a1.8,1.8,0,0,1,.866.023l.478,2.156-.06.022a2.248,2.248,0,0,0-1.361,1.634l-5.588,1.262-.844-3.571,1.891-.443a.352.352,0,0,0-.161-.686l-1.893.443-.031-.132a.353.353,0,0,0-.686.162l1.217,5.146a.353.353,0,0,0,.686-.162l-.017-.071,5.366-1.213a2.3,2.3,0,0,0,.16.672,2.008,2.008,0,0,0,.651.889,3.534,3.534,0,0,0,.745.4m-.535-3.163h0a1.6,1.6,0,0,1,.668-.515c.037-.015.071-.028.1-.038l.007,0a1.594,1.594,0,0,1,.574-.082h0a1.457,1.457,0,0,1,.211.023h.007a1.334,1.334,0,0,1,.2.05h0a1.606,1.606,0,0,1,.693.432h0a1.593,1.593,0,0,1,.32.492,1.617,1.617,0,0,1,.076,1.006,1.638,1.638,0,0,1-.185.451,1.619,1.619,0,0,1-1.782.738,1.633,1.633,0,0,1-.45-.188,1.613,1.613,0,0,1-.764-1.612,1.633,1.633,0,0,1,.316-.758m9.2-2.79h0a2.494,2.494,0,0,1-.28.023c-.035,0-.059,0-.087,0A.352.352,0,0,0,287,77.2a.348.348,0,0,0-.24-.022l0-.007-1.738.406-.272-1.163L286.484,76l0-.006a.342.342,0,0,0,.15-.069.35.35,0,0,0,.115-.349l-.008-.032.016-.019a1.863,1.863,0,0,1,.292-.213,1.343,1.343,0,0,1,.172-.091l.015-.007.5,2.141h0c-.014,0-.042.01-.076.015s-.075.013-.12.018m-4.224,1.528h0l-2.22.465a2.337,2.337,0,0,0-.77-.439,2.047,2.047,0,0,0-.295-.071v0h0l0,0a1.771,1.771,0,0,0-.537-.021l-.455-2.053,3.589-.84a1.517,1.517,0,0,1,.791.027,1.546,1.546,0,0,1,.594.355l.38,1.627a1.521,1.521,0,0,1-.835.877,1.545,1.545,0,0,1-.236.075",
    transform: "translate(-134.68 -37.161)",
    fill: "#fff"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3783",
    "data-name": "Group 3783",
    transform: "translate(143.101 42.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3782",
    "data-name": "Group 3782",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1606",
    "data-name": "Rectangle 1606",
    width: 3.754,
    height: 3.728,
    transform: "translate(-0.027)",
    fill: "url(#linear-gradient-12)"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3785",
    "data-name": "Group 3785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3784",
    "data-name": "Group 3784",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60275",
    "data-name": "Path 60275",
    d: "M289.089,86.6a.863.863,0,1,1-1.127-.467.862.862,0,0,1,1.127.467",
    transform: "translate(-143.346 -42.922)",
    fill: "#fff"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3787",
    "data-name": "Group 3787",
    transform: "translate(144.351 38.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3786",
    "data-name": "Group 3786",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1608",
    "data-name": "Rectangle 1608",
    width: 6.002,
    height: 4.593,
    transform: "matrix(0.974, -0.227, 0.227, 0.974, -0.767, 0.179)",
    fill: "url(#linear-gradient-13)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3804",
    "data-name": "Group 3804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3803",
    "data-name": "Group 3803",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_60277",
    "data-name": "Path 60277",
    d: "M278.421,81.779l-3.727-21C273.134,51.918,266.973,46,257.039,46a17.853,17.853,0,0,0-17.853,17.842,13.2,13.2,0,0,0,5.963,11.134H231.755l.024.024-5.45-.012,1.06,6.755,13,.035-.012-.035ZM257.039,52.64a11.089,11.089,0,0,1,11.017,9.34L270.4,75.14l-13.358-.046a11.227,11.227,0,0,1,0-22.454",
    transform: "translate(-112.873 -22.942)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60278",
    "data-name": "Path 60278",
    d: "M285.756,127.635l-17.341,3.377-.547-2.259,17.33-3.389Z",
    transform: "translate(-133.59 -62.521)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3792",
    "data-name": "Group 3792",
    transform: "translate(13.595 52.035)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3791",
    "data-name": "Group 3791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3790",
    "data-name": "Group 3790",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3789",
    "data-name": "Group 3789",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3788",
    "data-name": "Group 3788",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_1609",
    "data-name": "Rectangle 1609",
    width: 11.028,
    height: 7.519,
    transform: "translate(-0.061 -0.496)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAPCAYAAADgbT9oAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABKSURBVDhP7YzLDcAwCMXwG6H7b0l6TgFFdILcsBQ5H2LMng28SEuw0ojYl52w4pyu+3yvOfzMxPr/HrvsEhNuJtxMuJlwcyls9gFKkBWNr2NiIAAAAABJRU5ErkJggg=="
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3797",
    "data-name": "Group 3797",
    transform: "translate(47.825 52.035)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3796",
    "data-name": "Group 3796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3795",
    "data-name": "Group 3795",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3794",
    "data-name": "Group 3794",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3793",
    "data-name": "Group 3793",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_1611",
    "data-name": "Rectangle 1611",
    width: 18.548,
    height: 7.519,
    transform: "translate(-0.204 -0.496)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAPCAYAAABjqQZTAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABlSURBVEhL7Y5BCoAwDAR3fYL//5NP8OIjGhA0JrTFW4497EBIu2nDENgfkLcfjGTz+rp5Fj0Lkf8zv6O/j7+ZZR97Mhvz3IM5y0Lru6/zsA0LIqkqkqoiqSqSqiKpKpKqsqAU8ALC1Scb2i+sJQAAAABJRU5ErkJggg=="
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3802",
    "data-name": "Group 3802",
    transform: "translate(93.868 52.035)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3801",
    "data-name": "Group 3801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3800",
    "data-name": "Group 3800",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3799",
    "data-name": "Group 3799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3798",
    "data-name": "Group 3798",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_1613",
    "data-name": "Rectangle 1613",
    width: 16.041,
    height: 7.519,
    transform: "translate(-0.127 -0.496)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAPCAYAAACFgM0XAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABISURBVEhLY2RgEPrPyMj4C4h/MAAxiIbi70hsOEaoYYCJfWdkQsiDMJo5MIxiHkwNE8MAg1EHjDpg1AGjDhh1wKgDBtgBDAwAGPofj5eL1JgAAAAASUVORK5CYII="
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrk19);
export default __webpack_public_path__ + "static/media/wrk-19.7a5bf624fdfdb0b9572100006e0db11d.svg";
export { ForwardRef as ReactComponent };